import { Base_Url } from "./baseurl";
import { apiGetHelper } from "../helpers/apiHelper";

const getHangmanQuestions = async()=>{
    try{
        const response = await apiGetHelper("get",`${Base_Url.base_url}/getHangmanQuestions`, "IsError");
        console.log(response.data,"HM");
        return response.data;
    }catch(error){
        console.log(error);
        return null;
    }
}

export { getHangmanQuestions };